module.exports = __webpack_public_path__ + "img/hometop_xl.b80088ad.png";